export default {
  lista: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
}
